import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = ({ row: tranche }: ITranchRow) => (
  tranche.benchmark
    ? tranche.benchmark.name
    : '-'
);

const BenchmarkCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="BenchmarkCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default BenchmarkCell;
